import { takeLatest, call, put } from "redux-saga/effects";
import { request } from "@thewebops/admin-panel";
import actions from "./actions";
import { showNotification } from "@thewebops/admin-panel";
import { saveAs } from "file-saver";

function* downloadDeleteTemplate(action) {
  const { success, failure } = actions.downloadDeleteTemplate;
  try {
    const response = yield call(request, {
      url: `admin/deleted_products/download_template.xlsx`,
      method: "get",
      authenticated: true,
      isDownloading: true,
    });
    yield call(saveAs, response.data, "delete_template.xlsx");
    yield put(success());
  } catch (error) {
    showNotification(null, "error", JSON.stringify(error.message));
    yield put(failure());
  }
}

function* watchEntityDownloadDeleteTemplate() {
  const { request } = actions.downloadDeleteTemplate;
  yield takeLatest(request, downloadDeleteTemplate);
}

export default [watchEntityDownloadDeleteTemplate];
